import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, useMemo, } from 'react';
import theme from '../../styles/theme';
import { footerReverseAtSizes, footerTypes, } from './constants';
const defaultProps = {
    reverseAt: footerReverseAtSizes.small,
    type: footerTypes.primary,
};
const ModalFooterContent = ({ children, reverseAt = defaultProps.reverseAt, type = defaultProps.type, }) => {
    const footerContentStyles = useMemo(() => (css `
        display: flex;
        flex-shrink: 0;
        flex-grow: 1;
        flex-wrap: wrap;
        flex-direction: row;

        & > * + * {
          margin-left: ${theme.spacing.x3};
        }
        order: 0;
        justify-content: flex-start;
        ${type === footerTypes.primary && css `
          order: 1;
          justify-content: flex-end;
        `}

        ${reverseAt !== footerReverseAtSizes.none && css `
          ${theme.media.lessThan(reverseAt) `
            flex-direction: column-reverse;

            & > * {
              margin-bottom: 0;
              margin-left: 0;
              margin-right: 0;
              margin-top: 0;
            }
          `}
        `}
      `), [
        reverseAt,
        type,
    ]);
    return (_jsx("div", Object.assign({ css: footerContentStyles }, { children: children })));
};
const MemoizedModalFooterContent = memo(ModalFooterContent);
export { MemoizedModalFooterContent as ModalFooterContent };
// MC-1068 Temporary hack for Storybook.
export default ModalFooterContent;
